import * as React from 'react';

export const Icon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 18C35 27.3888 27.3888 35 18 35C8.61116 35 1 27.3888 1 18C1 8.61116 8.61116 1 18 1C27.3888 1 35 8.61116 35 18ZM26.5716 18.925C26.7394 19.1193 26.6013 19.4211 26.3445 19.4211H21.6V27H14.4V19.4211H9.65549C9.39865 19.4211 9.26057 19.1193 9.42844 18.925L18 9L26.5716 18.925Z"
      fill="#152242"
      fillOpacity="0.9"
    />
  </svg>
);
